enum SubscriptionFrequency {
  WEEKLY = 'Weekly',
  BI_WEEKLY = 'Biweekly',
  MONTHLY = 'Monthly',
  BI_MONTHLY = 'Bimonthly',
  QUARTERLY = 'Quarterly',
  HALF_YEARLY = 'Halfyearly',
  YEARLY = 'Yearly',
}

export default SubscriptionFrequency;
